module.exports = __webpack_public_path__ + "img/smoke.6ea00a37.svg";